import * as React from 'react';
import {IocStore} from "../stores/ioc";
import {observer} from "mobx-react-lite";
import {Redirect, useParams} from "react-router-dom"
import CheckIocData from "../components/CheckIoc/CheckIocData";

const CheckIocResultsPage = observer(function CheckIocResultsPage(props: { store: IocStore }) {
    const params: { ioc: string } = useParams()
    const data = props.store.data.filter(x => x.ioc === params.ioc)

    if (!data.length) {
        props.store.ioc = params.ioc
        return <Redirect to={{
            pathname: "/auth",
            state: {check: 'ioc'}
        }}/>
    }

    return <CheckIocData data={data[0]}/>
})

export default CheckIocResultsPage